import { Responsive } from '@cian/ui-kit';
import { LayoutsWidgetDesktop } from '../LayoutsWidgetDesktop';
import { LayoutsWidgetMobile } from '../LayoutsWidgetMobile';

export const LayoutsWidget = () => {
  return (
    <>
      <Responsive desktop>
        <LayoutsWidgetDesktop />
      </Responsive>
      <Responsive phone tablet>
        <LayoutsWidgetMobile />
      </Responsive>
    </>
  );
};
